/// <amd-module name="SuiteCommerce.Blog.LatestPosts.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.LatestPosts.Model", ["require", "exports", "SuiteCommerce.Blog.ExtCarousel.Model"], function (require, exports, ExtCarousel_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LatestPostsModel = void 0;
    var LatestPostsModel = /** @class */ (function (_super) {
        __extends(LatestPostsModel, _super);
        function LatestPostsModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return LatestPostsModel;
    }(ExtCarousel_Model_1.ExtCarouselModel));
    exports.LatestPostsModel = LatestPostsModel;
});
